import { jsxs as r, jsx as C } from "react/jsx-runtime";
function t(e) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M17.9395 5L11.4698 11.4697C11.1768 11.7627 11.1768 12.2373 11.4698 12.5302C11.6163 12.6767 11.8077 12.7499 12.0001 12.7499C12.1925 12.7499 12.3839 12.6767 12.5304 12.5302L19.0001 6.0605L20.4698 7.5302C20.6134 7.6738 20.8048 7.7499 21.0001 7.7499C21.0968 7.7499 21.1944 7.7313 21.2872 7.6928C21.5675 7.5766 21.7501 7.3032 21.7501 6.9999V3C21.7501 2.9023 21.7301 2.8051 21.6922 2.7134C21.6162 2.5301 21.47 2.384 21.2867 2.3079C21.195 2.2699 21.0977 2.25 21.0001 2.25H17.0001C16.6964 2.25 16.423 2.4326 16.3067 2.7129C16.1915 2.9932 16.2549 3.3159 16.4698 3.5303L17.9395 5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M20.0004 11L20.001 20H4V4H13V2H4C2.8975 2 2 2.897 2 4V20C2 21.103 2.8975 22 4 22H20C21.1025 22 22 21.103 22 20V11H20.0004Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
